"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboxFacetAbi = exports.BridgeFacetAbi = exports.TokenFacetAbi = exports.ConnextAbi = void 0;
const IConnext_json_1 = __importDefault(require("../abi/contracts/core/connext/interfaces/IConnext.sol/IConnext.json"));
const TokenFacet_json_1 = __importDefault(require("../abi/contracts/core/connext/facets/TokenFacet.sol/TokenFacet.json"));
const BridgeFacet_json_1 = __importDefault(require("../abi/contracts/core/connext/facets/BridgeFacet.sol/BridgeFacet.json"));
const InboxFacet_json_1 = __importDefault(require("../abi/contracts/core/connext/facets/InboxFacet.sol/InboxFacet.json"));
exports.ConnextAbi = IConnext_json_1.default;
exports.TokenFacetAbi = TokenFacet_json_1.default;
exports.BridgeFacetAbi = BridgeFacet_json_1.default;
exports.InboxFacetAbi = InboxFacet_json_1.default;
//# sourceMappingURL=abi.js.map